const comments = [
  {
    name: '吃瓜第一线',
    time: '3分钟前',
    content: '这个瓜我吃了三天了，越挖越深，简直比电视剧还精彩！91黑料的更新速度真的快，其他地方都还没发这里就有了。',
    likes: '2.3万',
  },
  {
    name: '娱乐圈老司机',
    time: '15分钟前',
    content: '早就听说这个料了，但一直没人敢爆。今天终于在91黑料看到完整版了，信息量太大了，我需要慢慢消化。',
    likes: '1.8万',
  },
  {
    name: '真相挖掘机',
    time: '28分钟前',
    content: '作为业内人士说一句，这里面爆出来的东西只是冰山一角。真正的料比这个劲爆十倍，就看有没有人敢继续挖了。',
    likes: '3.1万',
  },
  {
    name: '开心果果',
    time: '42分钟前',
    content: '每天睡前必刷91黑料，已经成为我的固定节目了。今天的爆料真的太炸裂了，转发给朋友群瞬间炸锅。',
    likes: '1.5万',
  },
  {
    name: '深夜吃瓜人',
    time: '1小时前',
    content: '刚从微博过来，那边已经炸了。91黑料的评论区比微博精彩多了，大家都是真敢说，不像微博全是控评的。',
    likes: '2.7万',
  },
];

export default function CommentsSection() {
  return (
    <section id="comments" className="py-16 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="mb-10">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 mb-3">
            💬 网友热议
          </h2>
          <p className="text-sm text-foreground-600">
            看看大家都怎么说，加入讨论发表你的观点
          </p>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5">
          {comments.map((comment, idx) => (
            <div
              key={idx}
              className="bg-background-100/70 border border-background-200/50 rounded-xl p-5 hover:border-primary-100/50 transition-all duration-300"
            >
              <div className="flex items-center gap-3 mb-3">
                <div className="w-10 h-10 rounded-full bg-accent-100 flex items-center justify-center flex-shrink-0">
                  <span className="text-accent-700 font-bold text-sm">
                    {comment.name.charAt(0)}
                  </span>
                </div>
                <div className="flex-1 min-w-0">
                  <div className="font-medium text-sm text-foreground-900 whitespace-nowrap">
                    {comment.name}
                  </div>
                  <div className="text-xs text-foreground-500 flex items-center gap-1">
                    <i className="ri-time-line"></i>
                    {comment.time}
                  </div>
                </div>
              </div>
              <p className="text-sm text-foreground-700 leading-relaxed mb-4">
                {comment.content}
              </p>
              <div className="flex items-center gap-4 text-xs text-foreground-500">
                <button className="flex items-center gap-1.5 hover:text-primary-500 transition-colors cursor-pointer whitespace-nowrap">
                  <i className="ri-heart-line"></i>
                  {comment.likes}
                </button>
                <button className="flex items-center gap-1.5 hover:text-primary-500 transition-colors cursor-pointer whitespace-nowrap">
                  <i className="ri-chat-1-line"></i>
                  回复
                </button>
                <button className="flex items-center gap-1.5 hover:text-primary-500 transition-colors cursor-pointer whitespace-nowrap">
                  <i className="ri-share-forward-line"></i>
                  分享
                </button>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}